import { Component, OnInit } from '@angular/core';
import { downgradeToAJSComponent } from 'ib-web-commons/utils';
import { IbGiftCardsContributionService } from '../../services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';
import { contributionDataResponse } from '@src/app/core/models/contribution.model';


@Component({
    selector: 'ib-gc-new-contribution-component',
    templateUrl: './ib-gift-cards-new-contribution.component.html'
})

export class IbGiftCardsNewContributionComponent implements OnInit {
    constructor ( 
        public IbGiftCardsContributionService: IbGiftCardsContributionService
    ) {}
    ngOnInit (): void {
        this.getContributionData();
    }

    getContributionData = () => {
        this.IbGiftCardsContributionService.getContributionData().then((res: contributionDataResponse) => {
            this.getAvailabilityData(res.flowId);
        }).catch((error) => {
            
        });
    };

    getAvailabilityData = (flowId: string) => {
        this.IbGiftCardsContributionService.getAvailabilityData(flowId).then((res: contributionDataResponse) => {
        }).catch((error) => {
            
        });
    };
}

downgradeToAJSComponent('ibGcNewContributionComponent', {
    component: IbGiftCardsNewContributionComponent,
    inputs: []
}, 'ib-gc-new-contribution');
